import React, { useEffect, useState, useMemo } from 'react';
import styles from './TopicFilterLayout.module.scss'
import Button from 'src/components/button/Button';
import IconRotating from 'src/assets/icons/rotating_arrow.svg?react';
import IconClose from 'src/assets/icons/close.svg?react';
import './customStyle.css';
import { Select, Tag } from "antd";
import type { CustomTagProps } from 'rc-select/lib/BaseSelect';

type Props = {
  handleChangeTopic: (value: string[]) => void;
  handleResetFilters: () => void
  handleFaithContentEnable?: (value: boolean) => void
  topics: string[]
  topicOptions: string[];
  faithEnable?: boolean;
  disabled?: boolean;
}

const tagRender = (props: CustomTagProps) => {
  const { label, closable, onClose } = props;
  const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };
  const colors = ['pink', 'red', 'yellow', 'orange', 'cyan', 'green', 'blue', 'purple', 'geekblue', 'magenta', 'volcano', 'gold', 'lime']
  const color = label === "All" ? "default" : colors[Math.floor(Math.random() * colors.length)];
  return (
    <Tag
      color={color}
      onMouseDown={onPreventMouseDown}
      closable={label !== "All" ? closable : false}
      onClose={onClose}
      closeIcon={
        <div className={styles.closeIcon} onClick={onClose}>
          <IconClose width={12} fill={color} />
        </div>  
      }
      className={styles.tabStyle}
      style={{ marginRight: '6px', display: 'flex' }}
    >
      {label}
    </Tag>
  );
};

function TopicFilterLayout(props: Props) {
  const { topics, topicOptions, handleResetFilters, handleChangeTopic } = props

  const isTablet = useMemo(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    return /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent)
  }, []);

  const [ tagValues, setTagValues ] = useState<string[]>([])
  const [enable, setEnable] = useState(false);
  const [onBlur_disable, setOnBlurDisable] = useState(false);

  useEffect(() => {
    if (topics.length > 0) {
      setTagValues(topics)
    } else {
      setTagValues(['All'])
    }
  }, [topics]);

  const options = useMemo(() => topicOptions.map(topic => ({ label: topic, value: topic })), [topicOptions]);

  const handleFocus = (open: boolean) => {
    if (isTablet) {
      if (!onBlur_disable) {
        setEnable(open)
      }
      setOnBlurDisable(open)
    } else {
      setEnable(open)
    }
  }
  return (
    <div className={styles.filterBanner}>
      <div className={styles.topicFilters}>
        <div className={styles.filterBox}>
          <Select
            mode="multiple"
            showArrow
            className={styles.topicSelect}
            tagRender={tagRender}
            value={tagValues}
            onChange={handleChangeTopic}
            optionLabelProp="label"
            options={options}
            open={enable}
            onDropdownVisibleChange={handleFocus}
            >
          </Select>
        </div>
        <Button onClick={handleResetFilters} className={styles.resetBtn} label={'Reset'}
          size={'extraSmall'} outline={true} color={'green'}
          leftIcon={<IconRotating className={styles.resetIcon} />} />
      </div>
    </div>
  )
}

export default TopicFilterLayout